import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManufacturerTableViewComponent } from './manufacturer-table-view/manufacturer-table-view.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [ManufacturerTableViewComponent],
  imports: [CommonModule, SharedModule, MatSortModule, MatSlideToggleModule],
  exports: [RouterModule],
})
export class ManufacturerModule {}
